import React from "react";

function Pune(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M7.12756 3H16.9527V4.48283H7.12756V3Z"
        stroke="#17142A"
        strokeWidth="0.371636"
        strokeMiterlimit="10"
      />
      <path
        d="M7.81323 4.48291H16.4761V8.4715H7.81323V4.48291Z"
        stroke="#17142A"
        strokeWidth="0.371636"
        strokeMiterlimit="10"
      />
      <path
        d="M7.81323 6.91602H16.4761"
        stroke="#17142A"
        strokeWidth="0.371636"
        strokeMiterlimit="10"
      />
      <path
        d="M9.83337 4.48291V7.03048"
        stroke="#17142A"
        strokeWidth="0.371636"
        strokeMiterlimit="10"
      />
      <path
        d="M14.3162 4.48291V6.9162"
        stroke="#17142A"
        strokeWidth="0.371636"
        strokeMiterlimit="10"
      />
      <path
        d="M2.71802 7.87207H7.79921V9.4413H2.71802V7.87207Z"
        stroke="#17142A"
        strokeWidth="0.371636"
        strokeMiterlimit="10"
      />
      <path
        d="M9.30436 20.1362H1.5V11.2866V9.44141H9.30436V20.1362Z"
        stroke="#17142A"
        strokeWidth="0.371636"
        strokeMiterlimit="10"
      />
      <path
        d="M9.30436 11.3228H1.5"
        stroke="#17142A"
        strokeWidth="0.371636"
        strokeMiterlimit="10"
      />
      <path
        d="M3.58997 12.2983V14.7902"
        stroke="#17142A"
        strokeWidth="0.371636"
        strokeMiterlimit="10"
      />
      <path
        d="M5.40259 12.2983V14.7902"
        stroke="#17142A"
        strokeWidth="0.371636"
        strokeMiterlimit="10"
      />
      <path
        d="M7.42273 12.2983V14.7902"
        stroke="#17142A"
        strokeWidth="0.371636"
        strokeMiterlimit="10"
      />
      <path
        d="M2.90771 9.44141V11.3228"
        stroke="#17142A"
        strokeWidth="0.371636"
        strokeMiterlimit="10"
      />
      <path
        d="M4.62683 9.44141V11.3228"
        stroke="#17142A"
        strokeWidth="0.371636"
        strokeMiterlimit="10"
      />
      <path
        d="M6.34424 9.44141V11.3228"
        stroke="#17142A"
        strokeWidth="0.371636"
        strokeMiterlimit="10"
      />
      <path
        d="M8.06323 9.44141V11.3228"
        stroke="#17142A"
        strokeWidth="0.371636"
        strokeMiterlimit="10"
      />
      <path
        d="M16.4894 7.87207H22.0165V9.4413H16.4894V7.87207Z"
        stroke="#17142A"
        strokeWidth="0.371636"
        strokeMiterlimit="10"
      />
      <path
        d="M22.5713 20.1362H14.767V11.2866V9.44141H22.5713V20.1362Z"
        stroke="#17142A"
        strokeWidth="0.371636"
        strokeMiterlimit="10"
      />
      <path
        d="M22.5713 11.3228H14.767"
        stroke="#17142A"
        strokeWidth="0.371636"
        strokeMiterlimit="10"
      />
      <path
        d="M16.8577 12.2983V14.7902"
        stroke="#17142A"
        strokeWidth="0.371636"
        strokeMiterlimit="10"
      />
      <path
        d="M18.6687 12.2983V14.7902"
        stroke="#17142A"
        strokeWidth="0.371636"
        strokeMiterlimit="10"
      />
      <path
        d="M20.6897 12.2983V14.7902"
        stroke="#17142A"
        strokeWidth="0.371636"
        strokeMiterlimit="10"
      />
      <path
        d="M16.1747 9.44141V11.3228"
        stroke="#17142A"
        strokeWidth="0.371636"
        strokeMiterlimit="10"
      />
      <path
        d="M17.8947 9.44141V11.3228"
        stroke="#17142A"
        strokeWidth="0.371636"
        strokeMiterlimit="10"
      />
      <path
        d="M19.6111 9.44141V11.3228"
        stroke="#17142A"
        strokeWidth="0.371636"
        strokeMiterlimit="10"
      />
      <path
        d="M21.3311 9.44141V11.3228"
        stroke="#17142A"
        strokeWidth="0.371636"
        strokeMiterlimit="10"
      />
      <path
        d="M9.30432 10.1548H14.7674"
        stroke="#17142A"
        strokeWidth="0.371636"
        strokeMiterlimit="10"
      />
      <path
        d="M13.8782 20.1361V13.9344C13.8782 13.6943 13.8309 13.4565 13.739 13.2347C13.6471 13.0129 13.5125 12.8113 13.3427 12.6415C13.1729 12.4717 12.9713 12.337 12.7495 12.2451C12.5276 12.1533 12.2899 12.106 12.0498 12.106C11.8096 12.106 11.5719 12.1533 11.35 12.2451C11.1282 12.337 10.9266 12.4717 10.7569 12.6415C10.5871 12.8113 10.4524 13.0129 10.3605 13.2347C10.2686 13.4565 10.2213 13.6943 10.2213 13.9344V20.1361H13.8782Z"
        stroke="#17142A"
        strokeWidth="0.371636"
        strokeMiterlimit="10"
      />
      <path
        d="M8.74719 20.1362H16.8582"
        stroke="#17142A"
        strokeWidth="0.371636"
        strokeMiterlimit="10"
      />
    </svg>
  );
}

const MemoPune = React.memo(Pune);
export default MemoPune;
